import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'common/components/modules/modal';
import Radio from 'common/components/elements/inputs/radio-label';
import Icon from 'common/components/elements/icons';
import Button from 'common/components/elements/buttons/primary';
import cx from 'classnames';
import TruncateText from 'common/components/elements/truncate-text';

import './style.scss'

const SelectV2 = ({
   options,
   onSelectChange,
   placeholder,
   isEmpty,
   isEmptyText,
   children,
   activeValue,
   keyDisplayName,
   keyValue,
   onShowPlaceholderOnModal,
   screenType,
   modalPositiononMobile,
   errorMessage,
   label,
   blurColor,
   modalClassName,
   isCloseAction,
   iconName,
}) => {

   const [openSelectModal, setOpenSelectModal] = useState(false);
   const [showError, setShowError] = useState(false);
   const [active, setActive] = useState(activeValue);
   const [animate, setAnimate] = useState('up');

   let timerFetching = null;
   function closeOrOpenModal(_bool) {
      let time = _bool ? 100 : 800
      if(screenType !== 'mobile'){
         time = 0
      }
      setAnimate(_bool ? 'up' : 'down');
      timerFetching = setTimeout(() => {
         setOpenSelectModal(_bool);
      }, time);
   }

   useEffect(() => {
      if(errorMessage) {
         setShowError(true)
      }
      return () => {
         clearTimeout(timerFetching);
      };
   }, [errorMessage, timerFetching]);

   let modalSettings = {
      contentPosition: modalPositiononMobile,
      animate: animate,
   }
   if(screenType !== 'mobile') {
      modalSettings = {
         contentPosition: 'center',
      }
   }

   return (
      <>
         {
            label && (
               <span className='leading-tight text-major font-semibold select-none mb-2'>
                  {label}
               </span>
            )
         }
         <div
            role='presentation'
            onClick={ () => {
               closeOrOpenModal(!openSelectModal)
            } }
            className={ cx(
               {
                  [` h-12 select-none flex w-full items-center cursor-pointer border justify-between rounded-lg px-4 py-2 bg-panel dark:bg-black-field hover:bg-hover dark:hover:bg-hover-dark`]: true,
                  'border-divider': !(errorMessage && !!showError),
                  'border-error dark:border-error-dark': errorMessage && !!showError,
               }
            ) }
         >
            <div
               // style={ {
               //    width: 'calc(100% - 24px)',
               // } }
               className='flex '>
               {
                  active.icon && (
                     <div className='flex items-center justify-center mr-2 h-6 w-6'>
                        <Icon name={ active.icon } size='xl' />
                     </div>

                  )
               }
               <TruncateText
                  text={  !!active[keyDisplayName] ? active[keyDisplayName] : placeholder }
                  textClass={ `leading-tight whitespace-nowrap text-base font-normal` }
                  textSize='16px'
                  fontWeight='400'
                  // width='200px'
               />
            </div>
            <Icon name={ iconName ? iconName : 'arrow-down' } size={ '2xl' } color='secondary' darkColor='secondary' />
         </div>
         <span
            style={ !!errorMessage ? { minHeight: '14px' } : {} }
            className='text-sm text-error dark:text-error-dark block mt-1 leading-none'
         >
            {errorMessage && !!showError  ? errorMessage : ''}
         </span>
         {openSelectModal && (

            <Modal
               blurColor={ blurColor }
               roundedModal='xlg'
               contentPosition={ screenType === 'mobile' ? modalPositiononMobile : 'center'  }
               onClose={ () => closeOrOpenModal(false) }
               isCloseAction={ isCloseAction }
               { ...modalSettings }
            >
               <div className={ `select-options-modal flex flex-col ${ modalClassName }` }>
                  <div className='header-shadow px-5 py-3 flex items-center z-2'>
                     <div className='close-button w-6 h-6 mr-5'>
                        <Button
                           iconName='close'
                           fontIconColor='major'
                           darkIconcolor='major-dark'
                           classNames='h-full w-full'
                           backgroundColor='transparent'
                           waveColor='rgba(33, 33, 33, 0.8)'
                           padding='none'
                           onClick={ () => closeOrOpenModal(false) }
                        />
                     </div>
                     {
                        !!onShowPlaceholderOnModal && (
                           <div className='flex w-full items-center'>
                              <span className='leading-select-placeholder text-major dark:text-major-dark '>{placeholder}</span>
                           </div>
                        )
                     }
                  </div>
                  <div className='flex flex-col select-options ams-custom-scrool'>
                     {
                        isEmpty && (
                           <div className='px-4 py-8'>
                              <span className='leading-tight text-secondary dark:text-secondary-dark'>{isEmptyText}</span>
                           </div>
                        )
                     }
                     {
                        !isEmpty && options?.map((option, index) => {
                           return (
                              <div
                                 key={ option.id || index.toString() }
                                 className='border-b dark:border-divider-dark border-divider flex items-center bg-panel dark:bg-panel-dark'
                              >
                                 {
                                    option.icon && (
                                       <div className='flex items-center justify-center ml-2 h-6 w-6'>
                                          <Icon name={ option.icon } size='xl' />
                                       </div>

                                    )
                                 }
                                 <Radio
                                    label={ option[keyDisplayName] }
                                    id={ option[keyValue] }
                                    onChange={ () => {
                                       onSelectChange(option)
                                       setActive(option);
                                       closeOrOpenModal(false)
                                       setShowError(false)
                                    } }
                                    checked={ active[keyValue] === option[keyValue] }
                                 />
                              </div>

                           )
                        })
                     }
                  </div>
                  {
                     children && (
                        children
                     )
                  }
               </div>
            </Modal>
         )}

      </>
   );
};

SelectV2.propTypes = {
   options: PropTypes.array,
   onSelectChange: PropTypes.func,
   placeholder: PropTypes.string,
   isEmpty: PropTypes.bool,
   isEmptyText: PropTypes.string,
   children: PropTypes.any,
   activeValue: PropTypes.object,
   keyDisplayName: PropTypes.string,
   keyValue: PropTypes.string,
   screenType: PropTypes.string,
   modalPositiononMobile: PropTypes.string,
   errorMessage: PropTypes.string,
   onShowPlaceholderOnModal: PropTypes.bool,
   label: PropTypes.string,
   blurColor: PropTypes.string,
   modalClassName: PropTypes.string,
   isCloseAction: PropTypes.bool,
   iconName: PropTypes.string,
};
SelectV2.defaultProps = {
   keyDisplayName: 'display_name',
   keyValue: 'value',
   placeholder: 'Select',
   onSelectChange: () => {},
   activeValue: {},
   onShowPlaceholderOnModal: false,
   isEmpty: false,
   modalPositiononMobile: 'bottom',
   screenType: 'mobile',
   modalClassName: '',
}
export default memo(SelectV2);
